import { GalleryDto } from '@picflow/types';

export const sortGalleries = (galleries: GalleryDto[], sorting: string) => {
  const inverted = sorting.startsWith('-');
  const key = sorting.replace('-', '');

  if (key === 'title') {
    galleries.sort((a, b) => (a.title || 'Untitled').localeCompare(b.title || 'Untitled'));
    return;
  }

  if (inverted) {
    galleries.sort((a, b) => (a[key] > b[key] ? -1 : 1));
  } else {
    galleries.sort((a, b) => (a[key] > b[key] ? 1 : -1));
  }
};
